import { React, useState, useContext, useEffect, useLayoutEffect } from 'react';
import './Header.css';
import AuthContext from '../../../store/AuthContext';
import Dropdown from 'react-bootstrap/Dropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import RequestModal from '../../myRequests/RequestModal/RequestModal';
import RequestModalBroker from '../../myRequests/RequestModal/RequestModalBroker';

import MsgModal from '../../modals/msgModal/MsgModal';
import { useSelector, useDispatch } from 'react-redux';
import { getAllBrokerAssociatedBuyer } from '../../../redux/actions/rfqManagementApi';
import Sidebar from '../Sidebar/Sidebar';
import { Auth } from 'aws-amplify';
import { deleteArchiveNotification } from '../../../redux/actions/eventsApi';
import { viewAllNotification } from '../../../redux/reducers/eventsSlice';
import {
    isTruthyEnvFlag,
    getPlatformRole,
    getOrgName,
    dispatchHeaderStatsByRole,
    HeaderOrgStats,
    HeaderNotificationItems,
    HeaderRequestItems,
    shouldShowBuyerSupplierRequests,
    shouldShowBrokerRequests,
    shouldHideOpenKnotsRequestAndSettingsHeaderIcons,
    HeaderMobileNav,
    getDashboardPath,
} from './Header.helpers';
import { shouldUseKnotDashboardHeaderForRole } from '../../../config/openKnotsHostPaths';

const OPEN_KNOTS_HEADER_ICON_DIR = `${process.env.PUBLIC_URL}/images/openknots-header`;
const OPEN_KNOTS_ROUTE_BODY_CLASS = 'ok-host-route';

/** Figma 290:22305 top-bar icons (Open Knots routes only). */
const OpenKnotsHeaderIcon = ({ name }) => (
    <img
        src={`${OPEN_KNOTS_HEADER_ICON_DIR}/${name}.svg`}
        className={`ok-header-icon ok-header-icon--${name}`}
        alt=''
        aria-hidden='true'
    />
);

const Header = (props) => {
    const ctx = useContext(AuthContext);
    const baseUrlShowHeaderStatistics = process.env.REACT_APP_SHOW_HEADER_STATISTICS;
    const baseUrlShowRequestMangIcons = process.env.REACT_APP_SHOW_REQUEST_MANG_ICON;
    const [profileImgUrl] = useState(process.env.PUBLIC_URL + '/images/129 Knots Logo 2.png');
    const [isBarExpanded, setIsBarExpanded] = useState(false);
    const [selectedBuyer, setSelectedBuyer] = useState(ctx.associatedBuyer);

    const expandSidebar = () => {
        setIsBarExpanded(!isBarExpanded);
    };
    const hideSidebar = () => {
        setIsBarExpanded(false);
    };
    const { facility, events } = useSelector((state) => {
        return state.app;
    });
    const state = useSelector((state) => {
        return state.app;
    });
    const orgUlid = ctx.userData?.user_organizations[0]?.organization_ulid;
    const [showSideBar, setShowSidBar] = useState(false);
    const baseUrlReq = process.env.REACT_APP_REQUEST_MANAGEMENT;
    const [requestData, setRequestData] = useState([]);
    const [showRequestModal, setShowRequestModal] = useState(false);
    const [showRequestModalBroker, setShowRequestModalBroker] = useState(false);
    const [modalTitle, setModalTitle] = useState(false);
    const [modalType, setModalType] = useState(false);
    const [showMsgModal, setShowMsgModal] = useState(false);
    const [showNotificationDropdown, setShowNotificationDropdown] = useState(false);
    const baseUrlEvent = process.env.REACT_APP_EVENT_MANAGEMENT;

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const platformRole = getPlatformRole(ctx?.userData);
    const isOpenKnotsHeader = shouldUseKnotDashboardHeaderForRole(
        location.pathname,
        location.search,
        platformRole,
        { hasAssociatedBuyer: Boolean(ctx.associatedBuyer) },
    );
    const hideOpenKnotsRequestAndSettingsIcons = shouldHideOpenKnotsRequestAndSettingsHeaderIcons(
        isOpenKnotsHeader,
        platformRole,
    );
    const showHeaderOrgStatistics = isTruthyEnvFlag(baseUrlShowHeaderStatistics) && !isOpenKnotsHeader;

    useLayoutEffect(() => {
        document.body.classList.toggle(OPEN_KNOTS_ROUTE_BODY_CLASS, isOpenKnotsHeader);
        return () => document.body.classList.remove(OPEN_KNOTS_ROUTE_BODY_CLASS);
    }, [isOpenKnotsHeader]);

    const handleLogoutEvent = (userId) => {
        const payload = {
            payload: {
                event: 'Logged out',
                description: 'User logged out',
            },
            user_ulid: userId,
            type: 'account',
        };

        axios
            .post(`${baseUrlEvent}/event`, payload)
            .then((response) => {
                if (response.status === 200) {
                    // no-op
                }
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleLogout = () => {
        try {
            sessionStorage.setItem('logoutInitiated', '1');
            sessionStorage.removeItem('postLoginRedirect');
        } catch {
            // ignore
        }
        Auth.signOut();
        if (ctx.userData) {
            handleLogoutEvent(ctx.userData.user_ulid);
        }
        ctx.onLogout();
    };

    const handleSidebar = () => {
        setShowSidBar(!showSideBar);
    };

    const handleChatClick = () => {
        navigate('/chatEnquiry');
    };

    const getRequestByUserId = () => {
        const userId = ctx.userData && ctx.userData.user_ulid;
        if (userId) {
            axios
                .get(`${baseUrlReq}/requestor/${userId}?page=1&pageSize=3`)
                .then((res) => {
                    if (res.status === 200) {
                        setRequestData(res.data.payload);
                    }
                })
                .catch((error) => {
                    setRequestData([]);
                    if (error.response && error.response.status === 401) {
                        ctx.onLogout();
                    }
                });
        }
    };

    const handleRaiseRequest = () => {
        setShowRequestModal(true);
    };
    const handleRaiseRequestBroker = () => {
        setShowRequestModalBroker(true);
    };
    const handleMsgModal = () => {
        setShowMsgModal(!showMsgModal);
    };

    const handleRequestCloseModal = () => {
        setShowRequestModal(!showRequestModal);
    };
    const handleRequestCloseModalBroker = () => {
        setShowRequestModalBroker(!showRequestModalBroker);
    };
    const handleViewAllRequest = (request) => {
        navigate(`/requests`, { state: { data: request } });
    };

    const handleRequestMapping = (request) => {
        navigate(`/requests#${request?.ulid}`, { state: { data: request } });
    };
    useEffect(() => {
        dispatchHeaderStatsByRole(dispatch, orgUlid, getPlatformRole(ctx?.userData));
    }, [orgUlid, dispatch, ctx?.userData?.user_organizations]);


    const handleNotification = () => {
        navigate('/notifications', {
            state: { selectedBuyer }, // passing buyerId via state
        });
    };

    const handleNotificationClear = () => {
        const archivePay = {
            organization_ulid: ctx?.userData?.user_organizations[0]?.organization_ulid,
        };

        const queryWithCat = {
            organizationULID: ctx?.userData?.user_organizations[0]?.organization_ulid,
        };
        const archiveReq = { query: archivePay, geQuery: queryWithCat };
        dispatch(deleteArchiveNotification(archiveReq));
    };

    useEffect(() => {
        dispatch(viewAllNotification(false));
        if (ctx?.userData?.user_organizations[0]?.user_org_role_maps[0]?.platform_role === 'broker') {
            dispatch(getAllBrokerAssociatedBuyer(ctx?.userData?.user_ulid));
        }
    }, [dispatch, ctx?.userData?.user_ulid, ctx?.userData?.user_organizations]);

    const handleSelectChange = (e) => {
        setSelectedBuyer(e.target.value);
        ctx.handleBrokerAssociateBuyer(e.target.value);
        navigate('/dashboard');
    };

    const navigateToDashboard = () => {
        setSelectedBuyer('');
        ctx.handleBrokerAssociateBuyer('');
        const dashboardPath = getDashboardPath(ctx.userData);
        navigate(dashboardPath);
    };
    useEffect(() => {
        setSelectedBuyer(ctx.associatedBuyer);
    }, [ctx.associatedBuyer]);
    return (
        <>
            {showRequestModal && (
                <RequestModal
                    handleRequestCloseModal={handleRequestCloseModal}
                    setModalType={setModalType}
                    setModalTitle={setModalTitle}
                    handleMsgModal={handleMsgModal}
                    setShowMsgModal={setShowMsgModal}
                />
            )}
            {showRequestModalBroker && (
                <RequestModalBroker
                    handleRequestCloseModal={handleRequestCloseModalBroker}
                    setModalType={setModalType}
                    setModalTitle={setModalTitle}
                    handleMsgModal={handleMsgModal}
                    setShowMsgModal={setShowMsgModal}
                />
            )}
            {showMsgModal && <MsgModal title={modalTitle} type={modalType} onClick={handleMsgModal} />}
            <div className={`custom-header text-start${isOpenKnotsHeader ? ' custom-header--open-knots' : ''}`}>
                <div className='row m-0'>
                    <div className='col-auto ps-0 col-md-auto menu-icon me-0 pt-0'>
                        {isOpenKnotsHeader ? (
                            <button
                                type='button'
                                className='ok-header-menu-btn'
                                onClick={expandSidebar}
                                aria-label={isBarExpanded ? 'Close menu' : 'Open menu'}
                                aria-expanded={isBarExpanded}>
                                {isBarExpanded ? (
                                    <i className='bi bi-x text-white' aria-hidden='true'></i>
                                ) : (
                                    <OpenKnotsHeaderIcon name='menu' />
                                )}
                            </button>
                        ) : !isBarExpanded ? (
                            <i className='bi bi-list text-white custom-font-dh1' onClick={expandSidebar}></i>
                        ) : (
                            <i className='bi bi-x text-white custom-font-dh1' onClick={expandSidebar}></i>
                        )}
                    </div>
                    <div className='col-auto ps-0 col-md-auto'>
                        <img
                            src={profileImgUrl}
                            className='header-logo cursor'
                            alt='profile'
                            onClick={navigateToDashboard}
                        />
                    </div>
                    <div className='col pe-0 pe-md-2'>
                        <div className='row'>
                            <HeaderOrgStats
                                platformRole={getPlatformRole(ctx?.userData)}
                                orgName={getOrgName(ctx?.userData)}
                                showStatistics={showHeaderOrgStatistics}
                                state={state}
                                facility={facility}
                            />
                            <div className='col-md-auto text-end text-white float-end'>
                                <div className='d-flex flex-row-reverse align-items-center header-actions'>
                                    <div className='user-profile'>
                                        <Dropdown>
                                            <Dropdown.Toggle id='dropdown-basic' className='user-icon' aria-label='Profile'>
                                                {isOpenKnotsHeader ? (
                                                    <OpenKnotsHeaderIcon name='user' />
                                                ) : (
                                                    <span className='sf-user'></span>
                                                )}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => navigate('/myProfile')}>
                                                    {ctx.userData && ctx.userData.primary_email}
                                                </Dropdown.Item>
                                                <Dropdown.Divider className='borderBottom' />
                                                <Dropdown.Item onClick={() => handleLogout()}>Logout</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    {!hideOpenKnotsRequestAndSettingsIcons ? (
                                        <div className='d-none setting-icon'>
                                            {isOpenKnotsHeader ? (
                                                <OpenKnotsHeaderIcon name='settings' />
                                            ) : (
                                                <span className='sf-settings'></span>
                                            )}
                                        </div>
                                    ) : null}
                                    <div className='notification-dropdown'>
                                        <Dropdown
                                            show={showNotificationDropdown}
                                            onToggle={(isOpen) => setShowNotificationDropdown(isOpen)}>
                                            <Dropdown.Toggle id='dropdown-request' className='user-icon' aria-label='Notifications'>
                                                {isOpenKnotsHeader ? (
                                                    <OpenKnotsHeaderIcon name='notification' />
                                                ) : (
                                                    <span className='sf-notification'></span>
                                                )}
                                                {events.notificationTypeCounts &&
                                                    events.notificationTypeCounts?.all > 0 ? (
                                                    <span className={`notify-icon font-b4`}>
                                                        {events.notificationTypeCounts?.all}
                                                    </span>
                                                ) : null}
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <div className='mb-2'>
                                                    <p className='mb-0 d-flex justify-content-between align-items-center'>
                                                        <span className='font-b2 text-start font-semiBold'>
                                                            Notifications
                                                        </span>
                                                        <span
                                                            className='cursor font-b3 float-end clearall'
                                                            onClick={() => {
                                                                if (events.notificationTypeCounts?.all > 0) {
                                                                    handleNotificationClear();
                                                                }
                                                                setShowNotificationDropdown(false);
                                                            }}>
                                                            Clear All
                                                        </span>
                                                    </p>
                                                </div>
                                                <hr className='m-0' />
                                                <HeaderNotificationItems
                                                    notifications={events.newNotificationList}
                                                    onItemClick={() => {
                                                        handleNotification();
                                                        setShowNotificationDropdown(false);
                                                    }}
                                                />
                                                <div className='notification-footer'>
                                                    <Dropdown.Item
                                                        className='mb-0 text-center cursor notification-btn'
                                                        onClick={() => {
                                                            handleNotification();
                                                        }}>
                                                        View All
                                                    </Dropdown.Item>
                                                </div>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                    {shouldShowBuyerSupplierRequests(platformRole, baseUrlShowRequestMangIcons) &&
                                        !hideOpenKnotsRequestAndSettingsIcons && (
                                            <div className='d-none request-dropdown'>
                                                <Dropdown>
                                                    <Dropdown.Toggle id='dropdown-request' className='user-icon' aria-label='My requests'>
                                                        {isOpenKnotsHeader ? (
                                                            <span className='ok-header-icon-hit' onClick={getRequestByUserId}>
                                                                <OpenKnotsHeaderIcon name='headset' />
                                                            </span>
                                                        ) : (
                                                            <i className='bi bi-headset' onClick={getRequestByUserId}></i>
                                                        )}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <div className='p-2'>
                                                            <p className='mb-0'>
                                                                <span className='font-b2 text-start font-semiBold'>
                                                                    My Requests ({requestData.length})
                                                                </span>
                                                                <span
                                                                    className='cursor font-b3 float-end text-secondary-300 font-medium'
                                                                    onClick={handleRaiseRequest}>
                                                                    Raise a Request
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <hr className='m-0' />
                                                        <HeaderRequestItems
                                                            requestData={requestData}
                                                            onRequestClick={handleRequestMapping}
                                                        />

                                                        <div className='p-2'>
                                                            <p
                                                                className='font-b3 font-medium text-secondary-300 mb-0 text-center cursor'
                                                                onClick={() => handleViewAllRequest(requestData[0])}>
                                                                View All
                                                            </p>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        )}

                                    {shouldShowBrokerRequests(
                                        getPlatformRole(ctx.userData),
                                        baseUrlShowRequestMangIcons
                                    ) && (
                                            <div className='d-none request-dropdown'>
                                                <Dropdown>
                                                    <Dropdown.Toggle id='dropdown-request' className='user-icon' aria-label='My requests'>
                                                        {isOpenKnotsHeader ? (
                                                            <span className='ok-header-icon-hit' onClick={getRequestByUserId}>
                                                                <OpenKnotsHeaderIcon name='headset' />
                                                            </span>
                                                        ) : (
                                                            <i className='bi bi-headset' onClick={getRequestByUserId}></i>
                                                        )}
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <div className='p-2'>
                                                            <p className='mb-0'>
                                                                <span className='font-b2 text-start font-semiBold'>
                                                                    My Requests ({requestData.length})
                                                                </span>
                                                                <span
                                                                    className='cursor font-b3 float-end text-secondary-300 font-medium'
                                                                    onClick={handleRaiseRequestBroker}>
                                                                    Raise a Request
                                                                </span>
                                                            </p>
                                                        </div>
                                                        <hr className='m-0' />
                                                        <HeaderRequestItems
                                                            requestData={requestData}
                                                            onRequestClick={handleRequestMapping}
                                                        />

                                                        <div className='p-2'>
                                                            <p
                                                                className='font-b3 font-medium text-secondary-300 mb-0 text-center cursor'
                                                                onClick={() => handleViewAllRequest(requestData[0])}>
                                                                View All
                                                            </p>
                                                        </div>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        )}
                                    {getPlatformRole(ctx?.userData) === 'broker' && (
                                            <div className='custom-select-container border-end-gray'>
                                                <div className='custom-select-wrapper'>
                                                    <select
                                                        id='buyer-select'
                                                        className=' buyer-dropdown '
                                                        value={selectedBuyer}
                                                        onChange={handleSelectChange}>
                                                        <option value=''>All Buyers</option>
                                                        {state?.rfqMang?.allBrokerAssociatedBuyer?.map((buyer) => (
                                                            <option key={buyer.buyer_organization_ulid} value={buyer.buyer_organization_ulid}>
                                                                {buyer.buyer_organization_name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    <span className='custom-dropdown-icon'>&#9662;</span>
                                                </div>
                                            </div>
                                        )}
                                    {getPlatformRole(ctx?.userData) === 'supplier' && (
                                            <div className='setting-icon d-none align-items-center justify-content-center' onClick={handleChatClick}>
                                                <span className='sf-chat'></span>
                                                {events.notificationTypeCounts &&
                                                    events.notificationTypeCounts?.chat > 0 ? (
                                                    <span className={`notify-icon font-b4`}>
                                                        {events.notificationTypeCounts?.chat}
                                                    </span>
                                                ) : null}
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='d-none col-5 text-end d-md-none pe-0 pt-0'>
                        <i className='bi bi-list text-white custom-font-dh1' onClick={handleSidebar}></i>
                    </div>
                </div>

                <HeaderMobileNav
                    ctx={ctx}
                    showSideBar={showSideBar}
                    onSidebarClick={handleSidebar}
                    onLogout={handleLogout}
                />
                {showSideBar && <div className='sidebar-overlay' onClick={handleSidebar}></div>}
            </div>
            <Sidebar isBarExpanded={isBarExpanded} expandSidebar={expandSidebar} hideSidebar={hideSidebar} />
        </>
    );
};

export default Header;
